import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center relative z-10 max-w-[1200px] mx-auto"
        >
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-extrabold mb-12 leading-[1.1] tracking-tight text-neutral"
          >
            Your Strategic Edge in a Dynamic World.<br />
            Growth Starts Here
          </motion.h1>
          
          <div className="flex justify-center mt-16">
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="relative"
            >
              <motion.a 
                href="#contact" 
                className="relative inline-flex items-center justify-center overflow-hidden rounded-full group select-none"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <span className="absolute w-full h-full border-2 border-accent rounded-full"></span>
                <motion.span 
                  className="absolute inset-0 bg-gradient-to-r from-accent/80 via-accent to-accent/80 rounded-full"
                  animate={{
                    backgroundPosition: ['0% 50%', '100% 50%', '0% 50%'],
                  }}
                  transition={{
                    duration: 5,
                    repeat: Infinity,
                    ease: "easeInOut"
                  }}
                  style={{
                    backgroundSize: '200% 200%'
                  }}
                />
                <span className="relative px-12 py-5 text-2xl font-medium text-white transition-all duration-300 ease-out group-hover:tracking-wider" style={{ textShadow: '0 1px 2px rgba(0,0,0,0.3)' }}>
                  Get in Touch
                </span>
              </motion.a>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;